import { ReactNode } from 'react';
import useLayoutContext from '@common/hooks/useLayoutContext';
// components
import DashboardLayout from './dashboard';
import LogoOnlyLayout from './LogoOnlyLayout';
import '@common/utils/amplify/configureAmplifyApi';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  variant?: 'dashboard' | 'logoOnly';
};

export default function Layout({ variant = 'dashboard', children }: Props) {
  const { getTypedGuard } = useLayoutContext();

  const AuthGuard = getTypedGuard('AuthGuard');
  const MobileGuard = getTypedGuard('MobileGuard');
  const PageGuard = getTypedGuard('PageGuard');

  if (variant === 'logoOnly') {
    return <LogoOnlyLayout> {children} </LogoOnlyLayout>;
  }

  return (
    <AuthGuard>
      <MobileGuard>
        <PageGuard>
          <DashboardLayout> {children} </DashboardLayout>
        </PageGuard>
      </MobileGuard>
    </AuthGuard>
  );
}
